import { render, staticRenderFns } from "./PrivacyinfoDetail_20230817.vue?vue&type=template&id=41a761f9&scoped=true&"
import script from "./PrivacyinfoDetail_20230817.vue?vue&type=script&lang=js&"
export * from "./PrivacyinfoDetail_20230817.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyinfoDetail_20230817.vue?vue&type=style&index=0&id=41a761f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a761f9",
  null
  
)

export default component.exports